// Shared helpers for the read-only "School Orders" feature (staff access).
// Same feature as the app's School Orders tab (VMA/utils/schoolOrders.js).

// Rename the feature in ONE place.
export const SCHOOL_ORDERS_LABEL = 'School Orders';

export const NO_SECTION_ID = 'none';

export const formatAmount = (value) => {
  const n = Number(value) || 0;
  return `₹${n.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
};

export const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const pluralize = (n, one, many) => `${n} ${n === 1 ? one : (many || `${one}s`)}`;

// Turns an axios error into a user-facing message.
export const getErrorMessage = (err, fallback = 'Something went wrong. Please try again.') => {
  if (err?.response?.status === 403) return "You don't have access to this school";
  return err?.response?.data?.message || (err?.message && !err?.response ? 'Network error. Check your connection.' : fallback);
};

const csvCell = (v) => {
  const s = String(v == null ? '' : v);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** Downloads the student list as a CSV file (built in the browser). */
export const downloadOrdersCsv = (orders, fileName) => {
  const header = ['Student', 'Parent', 'Phone', 'Section', 'Order no.', 'Date', 'Items', 'Amount'];
  const rows = orders.map((o) => [
    o.studentName || '',
    o.parentName || '',
    o.phoneNumber || '',
    (o.sections || []).join(', '),
    o.orderNumber || '',
    formatDate(o.placedAt),
    o.itemCount || 0,
    Number(o.amount) || 0,
  ]);
  const csv = [header, ...rows].map((r) => r.map(csvCell).join(',')).join('\r\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName.replace(/[\\/:*?"<>|]+/g, '-') + '.csv';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
